import '../src/entry/vendorless-entries/issue-app/index.tsx';
